<template>
  <div class="nav-next">
    <div style="height:80px;">
      <div class="zNav zNav-fixed">
        <div class="zNav-content">
          <div :class="prefixCls + '-title'">
            <Routing :url="baseUrl.baseNuxt" :href="urlData.home">
              <img
                src="https://oss.zhulogic.com/operation_picture/logo.png"
                alt=""
                height="34px"
              />
            </Routing>
          </div>
          <div class="menu">
            <div
              :class="prefixCls + '-left-item'"
              class="nav-left-item-routing"
            >
              <Routing :url="baseUrl.baseNuxt" :href="urlData.home">
                <Button type="text">首页</Button>
              </Routing>
            </div>
            <div
              :class="prefixCls + '-left-item'"
              class="nav-left-item-routing"
            >
              <Routing :url="baseUrl.baseNuxt" :href="urlData.service">
                <Button type="text">生产供应服务</Button>
              </Routing>
            </div>
            <Dropdown>
              <div :class="prefixCls + '-left-item-dropdown'">
                <Button type="text">案例素材</Button
                ><Icon type="ios-arrow-down"></Icon>
              </div>
              <DropdownMenu slot="list">
                <DropdownItem
                  v-point="{
                    category: '导航-案例',
                    action: '点击事件',
                    label: '案例点击',
                    value: '',
                  }"
                >
                  <Routing :url="baseUrl.baseNuxt" :href="urlData.case">
                    案例
                  </Routing>
                </DropdownItem>
                <DropdownItem
                  v-point="{
                    category: '导航-素材库',
                    action: '点击事件',
                    label: '素材库点击',
                    value: '',
                  }"
                >
                  <Routing :url="baseUrl.baseNuxt" :href="urlData.products">
                    素材库
                  </Routing>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>

            <Dropdown>
              <div :class="prefixCls + '-left-item-dropdown'">
                <Button type="text">工作台</Button
                ><Icon type="ios-arrow-down"></Icon>
              </div>
              <DropdownMenu slot="list">
                <DropdownItem
                  v-point="{
                    category: '导航-聚合搜图',
                    action: '点击事件',
                    label: '聚合搜图',
                    value: '',
                  }"
                >
                  <Routing :url="baseUrl.baseNuxt" :href="urlData.so">
                    聚合搜图
                  </Routing>
                </DropdownItem>
                <DropdownItem
                  v-point="{
                    category: '导航-采集工具',
                    action: '点击事件',
                    label: '采集工具点击',
                    value: '',
                  }"
                >
                  <Routing :url="baseUrl.baseNuxt" :href="urlData.collect">
                    采集工具
                  </Routing>
                </DropdownItem>
                <DropdownItem
                  v-point="{
                    category: '导航-设计工具',
                    action: '点击事件',
                    label: '设计方案点击',
                    value: '',
                  }"
                >
                  <Routing :url="baseUrl.baseNext" :href="urlData.design">
                    设计工具
                  </Routing>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <div
              :class="prefixCls + '-left-item'"
              v-point="{
                category: '导航-设计工具',
                action: '点击事件',
                label: '设计方案点击',
                value: '',
              }"
            ></div>

            <div
              :class="prefixCls + '-left-item'"
              v-point="{
                category: '导航-恐龙商城',
                action: '点击事件',
                label: '恐龙商城点击',
                value: '',
              }"
            >
              <Routing :url="urlData.mall" :isClickLogin="true">
                <Button type="text">恐龙商城</Button>
              </Routing>
            </div>
          </div>
          <div :class="prefixCls + '-right'">
            <!-- mouseenter -->
            <div
              :class="prefixCls + '-right-item'"
              @click="searchBarShow = true"
              @mouseleave="!inputFocBlu ? (searchBarShow = false) : ''"
            >
              <div
                class="search-bar"
                v-if="searchBarShow"
                :class="
                  searchBarShow
                    ? ['animated', 'fast', 'fadeIn']
                    : ['animated', 'fast', 'fadeOut']
                "
              >
                <z-search
                  :filePolicy="filePolicy"
                  :fileType="fileType"
                  :ossPrefix="ossUrl"
                  :baseUrl="baseUrl"
                  :iconFont="iconFont"
                  :thisUrl="thisUrl"
                  @focusView="focusView"
                  @blurView="blurView"
                  @showInput="showInput"
                  @hideInput="hideInput"
                  @inputSearch="seachShowHandle"
                ></z-search>
              </div>

              <Tooltip placement="bottom" content="搜索">
                <Button type="text">
                  <i
                    style="font-size:18px;"
                    :class="iconFont + ' ' + 'icon-sousuo1'"
                  ></i>
                </Button>
              </Tooltip>
            </div>
            <div
              :class="prefixCls + '-right-item'"
              v-if="userInfo && Object.keys(userInfo).length > 0"
              v-point="{
                category: '导航-项目',
                action: '点击事件',
                label: '项目点击',
                value: '',
              }"
            >
              <Tooltip placement="bottom" content="项目">
                <Routing
                  reversal
                  :url="baseUrl.baseNext"
                  :href="urlData.projects"
                >
                  <Button
                    type="text"
                    id="create-project"
                    class="nothing-aftter"
                  >
                    <i
                      style="font-size:18px;"
                      :class="iconFont + ' ' + 'icon-xiangmu1'"
                    ></i>
                  </Button>
                </Routing>
              </Tooltip>
            </div>

            <div
              :class="prefixCls + '-right-item'"
              v-if="userInfo && Object.keys(userInfo).length > 0"
              v-point="{
                category: '导航-消息',
                action: '点击事件',
                label: '消息点击',
                value: '',
              }"
            >
              <Tooltip placement="bottom" content="消息">
                <Routing :url="baseUrl.baseNext" :href="urlData.msg">
                  <Button type="text" class="nothing-aftter">
                    <Badge dot :count="msgCount" class="msgDot">
                      <i
                        :class="iconFont + ' ' + 'icon-xiaoxi1'"
                        style="font-size:18px;"
                      ></i>
                    </Badge>
                  </Button>
                </Routing>
              </Tooltip>
            </div>

            <div
              v-if="userInfo && Object.keys(userInfo).length > 0"
              :class="[prefixCls + '-right-item', 'right-item-spaecail']"
              v-point="{
                category: '导航-个人中心',
                action: '点击事件',
                label: '个人中心点击',
                value: '',
              }"
              style="margin-left:10px;margin-top:5px;"
            >
              <Dropdown>
                <Routing
                  :url="baseUrl.baseNext"
                  :href="urlData.my"
                  style="display:block"
                >
                  <Avatar
                    v-if="userInfo.avatarFile"
                    :src="ossUrl + userInfo.avatarFile.key"
                  />
                  <Avatar icon="ios-person" v-if="!userInfo.avatarFile" />
                </Routing>
                <DropdownMenu slot="list">
                  <DropdownItem>
                    <Routing :url="baseUrl.baseNext" :href="urlData.order">
                      <span>我的订单</span>
                    </Routing>
                  </DropdownItem>
                  <DropdownItem>
                    <Routing :url="baseUrl.baseNext" :href="urlData.myPrice">
                      <span>我的询价</span>
                    </Routing>
                  </DropdownItem>

                  <DropdownItem>
                    <Routing :url="baseUrl.baseNext" :href="urlData.myProject">
                      <span>我的项目</span>
                    </Routing>
                  </DropdownItem>
                  <DropdownItem>
                    <Routing :url="baseUrl.baseNext" :href="urlData.favorite">
                      <span>我的收藏</span>
                    </Routing>
                  </DropdownItem>
                  <DropdownItem>
                    <Routing :url="baseUrl.baseOld" :href="urlData.regest">
                      <span>身份认证</span>
                    </Routing>
                  </DropdownItem>
                  <DropdownItem @click.native="logout">
                    <Routing>
                      <span>退出登录</span>
                    </Routing>
                  </DropdownItem>
                  <!-- <DropdownItem divided @click.native="logout">
                    退出登录
                  </DropdownItem> -->
                </DropdownMenu>
              </Dropdown>
            </div>

            <div
              v-if="!userInfo || Object.keys(userInfo).length === 0"
              :class="prefixCls + '-right-item'"
            >
              <Routing :url="baseUrl.baseNext" :href="urlData.login + redirect">
                <!-- :class="['animated', 'fast', 'fadeIn']" v-if="delarySign" -->
                <Button type="text">登录 | 注册</Button>
              </Routing>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const prefixCls = 'zNav'
import User from './user'
import Routing from './routing'
import Zsearch from '../search/search'
import Cookie from 'js-cookie'
import { urlData } from '../../constants/header-nav.js'

export default {
  name: 'ZNav',
  provide() {
    return {
      app: this,
    }
  },
  components: { User, Routing, Zsearch },
  data() {
    return {
      prefixCls: prefixCls,
      url: null,
      url2: null,
      dark: true,
      searchValue: '',
      searchBarShow: false,
      inputFocBlu: false,
      olnyShow: false,
      urlData: urlData,
      delarySign: false,
    }
  },
  props: {
    VUE_APP_COOKIE_DOMAIN: {
      type: String,
      default: '',
    },
    /* 当前 baseUrl */
    thisUrl: {
      type: String,
      default: '',
    },
    filePolicy: {
      type: [String, Object],
      default: '',
    },
    fileType: {
      type: [String, Number],
      default: 3,
    },
    /* 是否页面教程已经展示 */
    introLS: {
      type: String,
      default: '',
    },
    iconFont: {
      type: String,
      default: 'iconfont',
    },
    userInfo: {
      type: Object,
      default: function() {
        return {}
      },
    },
    // 三个项目的baseUrl
    baseUrl: {
      type: Object,
      default: function() {
        return {}
      },
    },
    //redirect
    redirect: {
      type: String,
      default: '/',
    },
    // oss Url
    ossUrl: {
      type: String,
      default: 'http://oss.zhulogic.com/',
    },
    // 区分是老项目还是新项目
    isOldZhulogic: {
      type: Boolean,
      default: false,
    },
    // 既不在老项目也不再新项目下
    other: {
      type: Boolean,
      default: false,
    },
    msgCount: {
      type: Number,
      default: 0,
    },

    // 设计工具地址
    stageUrl: {
      type: String,
      default: 'https://stage.zhulogic.com',
    },
  },
  methods: {
    /* 点击搜索框出现 */
    seachShowHandle(keyWord) {
      if (!keyWord) return
      this.$emit('search', keyWord.trim())
      this.hideInput()
    },
    uploadThings(name) {
      if (!name) return false
      this.$emit('openUserUpload', name)
    },
    /* 每日签到 */
    signin() {
      this.$emit('signinHandle')
    },
    /* 退出登录 */
    logout() {
      this.$emit('exit')
    },

    /* 获得焦点 */
    focusView() {
      this.inputFocBlu = true
      this.searchBarShow = true
    },
    /* 失去焦点 */
    blurView() {
      setTimeout(() => {
        if (!this.olnyShow) {
          this.inputFocBlu = false
          this.searchBarShow = false
        }
      }, 300)
    },
    showInput() {
      this.searchBarShow = true
      this.olnyShow = true
      this.inputFocBlu = true
    },
    hideInput() {
      this.olnyShow = false
      this.blurView()
    },
  },
  created() {
    if (!this.other) {
      this.url = this.isOldZhulogic ? '' : this.baseUrl.baseOld
      this.url2 = !this.isOldZhulogic ? '' : this.baseUrl.baseNext
    } else {
      this.url = this.isOldZhulogic ? '' : this.baseUrl.baseOld
      this.url2 = this.isOldZhulogic ? '' : this.baseUrl.baseNext
    }
  },
  mounted() {
    // if (Cookie.get("imgSearchText") || Cookie.get("imgSearchLocal")) {
    //   this.showInput();
    // } else {
    //   this.hideInput();
    // }

    setTimeout(() => {
      this.delarySign = true
    }, 2000)

    // 认证
    this.$on('authenticationHandle', () => {
      this.$emit('authentication')
    })

    // 跳转账号设置
    this.$on('setInfo', () => {
      location.href = `${this.baseUrl.baseOld}/my/personal/accountSetting`
    })

    // /* 滚动 */
    // window.addEventListener('scroll', () => {
    //   let h = document.documentElement.scrollTop || document.body.scrollTop
    //   let viewportHeight =
    //     window.innerHeight ||
    //     document.documentElement.clientHeight ||
    //     document.body.clientHeight ||
    //     0
    //   let scrollHeight = document.documentElement.scrollHeight || 0
    //   if (h >= 45 && scrollHeight - viewportHeight > 100) {
    //     this.dark = false
    //   } else {
    //     this.dark = true
    //   }
    // })
  },
  destroyed() {
    Cookie.remove('imgSearchLocal')
    Cookie.remove('imgSearchText')
    this.delarySign = false
  },
}
</script>
